import { ReactNode } from 'react';

import palette from '@lib/core/src/theme/palette';
import { Box } from '@mui/material';

import { AgentProcessCardContainer, AgentProcessCardTitle } from './AgentConfigStyles';

export const AgentProcessCard = ({
  startIcon,
  title,
  description,
  endIcon
}: {
  startIcon: ReactNode;
  title: string;
  description: string;
  endIcon?: ReactNode;
}) => (
  <AgentProcessCardContainer>
    <AgentProcessCardTitle>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {startIcon}
        {title}
      </Box>
      {endIcon}
    </AgentProcessCardTitle>
    <Box sx={{ padding: '0px 12px', color: palette.black, fontSize: '14px' }}>{description}</Box>
  </AgentProcessCardContainer>
);
